import { render, staticRenderFns } from "./MarkAsDone.vue?vue&type=template&id=4a45d6fc&scoped=true&"
import script from "./MarkAsDone.vue?vue&type=script&lang=js&"
export * from "./MarkAsDone.vue?vue&type=script&lang=js&"
import style0 from "../style/side-box.scss?vue&type=style&index=0&id=4a45d6fc&scoped=true&lang=scss&"
import style1 from "../style/staff.scss?vue&type=style&index=1&id=4a45d6fc&scoped=true&lang=scss&"
import style2 from "../style/mark-as-done.scss?vue&type=style&index=2&id=4a45d6fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a45d6fc",
  null
  
)

export default component.exports